export default "__VITE_ASSET__BPXk6Mys__"